import * as R from 'ramda';
import React, { memo } from 'react';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// ui
import { Box, Flex, ActionButton } from '../../../../ui';
//////////////////////////////////////////////////

const whiteColor = G.getTheme('colors.white');
const blueColor = G.getTheme('colors.dark.blue');
const greyColor = G.getTheme('colors.greyMatterhorn');

const getButtonStyles = (color) => ({
  mr: '4px',
  px: '6px',
  fontSize: 12,
  height: 'auto',
  textColor: color,
  minWidth: 'unset',
  borderRadius: '5px',
  bgColor: whiteColor,
  border: `1px solid ${color}`,
});

const ApproveDeclineExpense = memo((props) => {
  const {
    guid,
    type,
    status,
    disabled,
    payrollGuid,
    expenseParty,
    isReadOnlyMode,
    expenseChargeType,
    approveOrDeclineDriverExpenseRequest,
  } = props;

  if (isReadOnlyMode) return null;

  const hasPayroll = G.isNotNil(payrollGuid);
  const hasRequiredData = G.isAllNotNilOrNotEmpty([type, expenseParty, expenseChargeType]);

  const showStatus = G.isAnyTrue(
    hasPayroll,
    R.not(hasRequiredData),
    R.includes(status, [GC.FIELD_EXPENSE_STATUS_APPROVED, GC.FIELD_EXPENSE_STATUS_DECLINED]),
  );

  const showApprove = G.isAllTrue(
    hasRequiredData,
    R.not(disabled),
    R.not(hasPayroll),
    R.includes(status, [GC.FIELD_EXPENSE_STATUS_PENDING, GC.FIELD_EXPENSE_STATUS_DECLINED]),
  );

  const showDecline = G.isAllTrue(
    hasRequiredData,
    R.not(disabled),
    R.not(hasPayroll),
    R.includes(status, [GC.FIELD_EXPENSE_STATUS_PENDING, GC.FIELD_EXPENSE_STATUS_APPROVED]),
  );

  return (
    <Flex justifyContent='space-between'>
      {
        showStatus &&
        <Box>{G.getEnumLocale(status)}</Box>
      }
      {
        showApprove &&
        <ActionButton
          {...getButtonStyles(blueColor)}
          type='button'
          onClick={() => approveOrDeclineDriverExpenseRequest({ guid, type: 'approve' })}
        >
          {G.getWindowLocale('titles:approve', 'Approve')}
        </ActionButton>
      }
      {
        showDecline &&
        <ActionButton
          {...getButtonStyles(greyColor)}
          type='button'
          onClick={() => approveOrDeclineDriverExpenseRequest({ guid, type: 'decline' })}
        >
          {G.getWindowLocale('titles:decline', 'Decline')}
        </ActionButton>
      }
    </Flex>
  );
});

export default ApproveDeclineExpense;
